import { AST } from '@handlebars/parser';

import { NodeType } from '../../../node/types';

export const isContentStatement = (statement: AST.Statement): statement is AST.ContentStatement =>
  statement.type === NodeType.ContentStatement;
